import React from 'react';
import { CatalogItemList } from "../common/catalogItemList";
import { observer } from 'mobx-react';
import { action, makeObservable, observable } from 'mobx';
import { CatalogProxy } from "../services/catalogServiceAPI/catalogProxy";
import uniq from 'lodash/uniq';
import { Input, Button, Space, Typography, Spin } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const PAGE_SIZE = 40;

@observer
export class Category extends React.Component {
    catalogProxy = new CatalogProxy();

    @observable items = [];
    @observable page = 0;
    @observable hasMore = true;
    @observable resultsFetched = 0;
    @observable isLoading = false;
    @observable searchQuery = '';

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    @action.bound setSearchQuery = (query) => this.searchQuery = query;
    @action.bound setIsLoading = (isLoading) => this.isLoading = isLoading;
    @action.bound setResultsFetched = (amount) => this.resultsFetched = amount;
    @action.bound setItems = (items) => this.items.replace(items);
    @action.bound setHasMore = (hasMore) => this.hasMore = hasMore;
    @action.bound setPage = (page) => {
        this.page = page;
        this.fetch();
    }

    @action.bound prev = () => this.setPage(this.page - 1);
    @action.bound next = () => this.setPage(this.page + 1);

    componentWillMount() {
        this.fetch();
    }

    search = () => {
        this.setResultsFetched(0);
        return this.fetch(this.searchQuery);
    }

    clear = () => {
        this.setResultsFetched(0);
        this.setPage(0);
        this.setSearchQuery('');
        return this.fetch();
    }

    async fetch(query) {
        this.setIsLoading(true);
        this.setItems([]);
        const searchResults = await this.catalogProxy.search(this.buildQuery(query));
        this.setHasMore(searchResults.length === PAGE_SIZE);
        this.setResultsFetched(searchResults.length + this.resultsFetched);
        const itemIds = uniq(searchResults.map(({ itemId }) => itemId));
        const items = await this.catalogProxy.query(itemIds);
        this.setItems(items);
        this.setIsLoading(false);
    }

    buildQuery(searchQuery) {
        const query = {
            categoryId: this.props.match.params.id,
            amount: PAGE_SIZE,
            offset: this.resultsFetched,
            onlyReady: false,
        };

        if (typeof searchQuery !== 'undefined') {
            query.query = searchQuery;
        }

        return query;
    }

    render() {
        return (
            <Space direction="vertical" size={16} style={{ width: '100%', padding: '24px 32px' }}>
                <Input.Search
                    placeholder="Search this category…"
                    value={this.searchQuery}
                    onChange={e => this.setSearchQuery(e.target.value)}
                    onSearch={this.search}
                    allowClear
                    onClear={this.clear}
                    loading={this.isLoading}
                    style={{ maxWidth: 400 }}
                    enterButton
                />

                {this.isLoading && <Spin />}

                {!this.isLoading && this.items.length === 0 && (
                    <Typography.Text type="secondary">No results found</Typography.Text>
                )}

                {!this.isLoading && this.items.length > 0 && (
                    <CatalogItemList items={this.items} />
                )}

                <Space>
                    <Button
                        icon={<LeftOutlined />}
                        onClick={this.prev}
                        disabled={this.page === 0}
                    >
                        Prev
                    </Button>
                    <Typography.Text type="secondary">Page {this.page + 1}</Typography.Text>
                    <Button
                        icon={<RightOutlined />}
                        iconPosition="end"
                        onClick={this.next}
                        disabled={!this.hasMore}
                    >
                        Next
                    </Button>
                </Space>
            </Space>
        );
    }
}
